/**
 * 工具js集合
 */
/**
 * 时间戳 转换时间
 * @param {number} date:13位unix
 * @param {string} fmt:转换的格式 ["Y","M"]
 * */
export function formatDate (val, fmt = ['Y', 'M', 'D']) {
  if (!val) {
    return ''
  }
  let date = new Date(parseInt(val) * 1000)
  date = date.toString().replace('GMT+0900 (中国夏令时间)', 'GMT+0800 (中国标准时间)')
  date = new Date(date)
  let obj = {}
  let back = ''
  obj.Y = date.getFullYear() + '-'
  obj.M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
  obj.D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
  obj.h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  obj.m = date.getMinutes() < 10 ? ':0' + date.getMinutes() : ':' + date.getMinutes()
  obj.s = date.getSeconds() < 10 ? ':0' + date.getSeconds() : ':' + date.getSeconds()
  for (let item of fmt) {
    back = back + obj[item]
  }
  return back
};
/**
 * 时间格式化 但该项目没用到
 * */
const dateFormatter = (formatter, date) => {
  date = (date ? new Date(date) : new Date())
  const Y = date.getFullYear() + '',
    M = date.getMonth() + 1,
    D = date.getDate(),
    H = date.getHours(),
    m = date.getMinutes(),
    s = date.getSeconds()
  return formatter.replace(/YYYY|yyyy/g, Y)
    .replace(/YY|yy/g, Y.substr(2, 2))
    .replace(/MM/g, (M < 10 ? '0' : '') + M)
    .replace(/DD/g, (D < 10 ? '0' : '') + D)
    .replace(/HH|hh/g, (H < 10 ? '0' : '') + H)
    .replace(/mm/g, (m < 10 ? '0' : '') + m)
    .replace(/ss/g, (s < 10 ? '0' : '') + s)
}

// dateFormatter('YYYY-MM-DD HH:mm', '1995/02/15 13:55') //

/**
 * padLeftZero() 为未满二位数的值添加0
 * */
function padLeftZero (str) {
  return ('00' + str).substr(str.length)
};

/**
 * getStorage:获取缓存
 * @param name：获取的名字
 * */
export function getStorage (name) {
  // 根据名称获取缓存值 默认为空
  let [storageString = ''] = [localStorage.getItem(name)]
  // 如果未设置该缓存或没有值，直接返回空串
  if (storageString == null || storageString.length <= 0) {
    return ''
  }
  try {
    // 把缓存字符串转为对象、获取当前时间
    let [storageObj, nowTime] = [JSON.parse(storageString), new Date().getTime()]
    // 如果缓存对象不存在或为空，或者对象设置了时间值并且时间值小于当前时间(即已过期)，此时清除缓存
    if (!storageObj || (storageObj.expires != undefined && storageObj.expires < nowTime)) {
      common.cleanStorage(name)
      return null
    } else {
      // 如果有值且时间未过期，则返回值，如果没有value则没有设置过期时间，此时不是对象，直接返回缓存字符串
      return storageObj.value || storageString
    }
  } catch (e) {
    return storageString
  }
};

/**
 * setStorage:设置缓存
 * @param name：设置的名字
 * @param value：设置的值
 * @param time：设置的过期时间 默认30天
 * */
export function setStorage (name, value, time = 30) {
  // 获取过期时间的时间戳值和当前的时间戳
  let [days, nowTime] = [parseFloat(time) * 84000000, new Date().getTime()]
  // expires是过期时间
  localStorage.setItem(name, JSON.stringify({
    value: value,
    expires: nowTime + days
  }))
};

/**
 * cleanStorage:清除缓存
 * @param name：清除的名字
 * */
export function cleanStorage (name) {
  localStorage.removeItem(name)
};

/**
 * 获取url参数
 * */
export function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg) // 这里返回找到正则的匹配

  if (r != null) {
    return unescape(r[2]) // 这里返回对应的值
  } else {
    if (sessionStorage.wx_authorize_search) {
      var r1 = sessionStorage.wx_authorize_search.substr(1).match(reg)
      if (r1 != null) return unescape(r1[2])
    }
  }
  return null
};

/**
 * 数组去重
 * */

export function unique (arr) {
  // 可能有兼容 以后再检查
  return [...new Set(arr)]// 方法1
  // return Array.from(new Set(arr))//方法2
  // 方法3
  // const res = new Map();
  // return arr.filter((a) => !res.has(a) && res.set(a, 1));
  // 方法4
  // var temp = [];
  // var index = [];
  // var l = arr.length;
  // for(var i = 0; i < l; i++) {
  //   for(var j = i + 1; j < l; j++){
  //     if (arr[i] === arr[j]){
  //       i++;
  //       j = i;
  //     }
  //   }
  //   temp.push(arr[i]);
  //   index.push(i);
  // }
  // console.log(index);
  // return temp;
}
// 加
export function floatAdd (arg1, arg2) {
  var r1, r2, m
  try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
  try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2))
  return (floatMul(arg1, m) + floatMul(arg2, m)) / m
}

// 减
export function floatSub (arg1, arg2) {
  var r1, r2, m, n
  try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
  try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
  m = Math.pow(10, Math.max(r1, r2))
  // 动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((floatMul(arg1, m) - floatMul(arg2, m)) / m).toFixed(n)
}

// 乘
export function floatMul (arg1, arg2) {
  var m = 0, s1 = arg1.toString(), s2 = arg2.toString()
  try { m += s1.split('.')[1].length } catch (e) {}
  try { m += s2.split('.')[1].length } catch (e) {}
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}

// 除
export function floatDiv (arg1, arg2) {
  var t1 = 0, t2 = 0, r1, r2
  try { t1 = arg1.toString().split('.')[1].length } catch (e) {}
  try { t2 = arg2.toString().split('.')[1].length } catch (e) {}

  r1 = Number(arg1.toString().replace('.', ''))

  r2 = Number(arg2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}



// WEBPACK FOOTER //
// ./src/utils/myUtils.js